export default __webpack_public_path__ + "static/media/leon_mdrrmc_responder.435e6f48.png";